module.exports = __webpack_public_path__ + "img/banner-11-2@2x.b65c8214.jpg";